import { render, staticRenderFns } from "./FullSidebar.vue?vue&type=template&id=056f5033"
import script from "./FullSidebar.vue?vue&type=script&lang=js"
export * from "./FullSidebar.vue?vue&type=script&lang=js"
import style0 from "./FullSidebar.vue?vue&type=style&index=0&id=056f5033&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports